import script from "./ChatForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatForm.vue?vue&type=script&setup=true&lang=js"

import "./ChatForm.vue?vue&type=style&index=0&id=5805e728&lang=css"

const __exports__ = script;

export default __exports__